import React from "react"
import Dialog from "@hydrologiq/shared/chakra/Dialog"
import AssetAvailabilityCalendarWithData from "./AssetAvailabilityCalendarWithData"
import { useOrderWorkflow } from "@hydrologiq/shared/contexts/OrderWorkflowContext"

/**
 * Simple dialog wrapper for the calendar.
 * The calendar component owns its data fetching and reads directly from context.
 * This component is just responsible for the modal UI.
 */
const AssetAvailabilityCalendarDialogSimple: React.FC = () => {
  const { state, closeCalendar } = useOrderWorkflow()
  const calendarRef = React.useRef<{ handleBackClick: () => void } | null>(null)

  // Only render when calendar should be open
  if (!state.calendarOpen) {
    return null
  }

  const handleBack = () => {
    if (calendarRef.current?.handleBackClick) {
      calendarRef.current.handleBackClick()
    } else {
      closeCalendar()
    }
  }

  return (
    <Dialog
      open={true}
      setOpen={(isOpen: boolean) => !isOpen && closeCalendar()}
      title="Asset Availability Calendar"
      loading={false}
      disabled={false}
      footer={undefined}
      fullscreen={true}
      showCloseButton={false}
      showBackButton={true}
      onBack={handleBack}
    >
      <AssetAvailabilityCalendarWithData ref={calendarRef} onBack={closeCalendar} />
    </Dialog>
  )
}

export default AssetAvailabilityCalendarDialogSimple
